module.exports = __webpack_public_path__ + "img/spain.70c13cd0.svg";